
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Search } from "lucide-react";

const SiteNotFound: React.FC = () => {
  return (
    <div className="text-center p-8 bg-white rounded-lg shadow">
      <div className="inline-flex items-center justify-center w-16 h-16 bg-fabre-lightgreen rounded-full mb-6">
        <Search className="h-8 w-8 text-fabre-green" />
      </div>
      <h2 className="text-xl font-bold text-fabre-gray mb-3">Informations non disponibles</h2>
      <p className="text-gray-600 mb-6">
        Nous n'avons pas pu trouver les informations que vous recherchez. 
        Veuillez vérifier votre requête ou essayer une autre option.
      </p>
      <div className="flex justify-center flex-wrap gap-3">
        <Button asChild className="bg-fabre-green hover:bg-fabre-darkgreen">
          <Link to="/sites">Tous nos sites</Link>
        </Button>
        <Button asChild variant="outline" className="border-fabre-green text-fabre-green hover:bg-fabre-lightgreen">
          <Link to="/contact">Nous contacter</Link>
        </Button>
      </div>
    </div>
  );
};

export default SiteNotFound;
